import React from 'react';

import { LibraryToolbar, LibraryList } from 'views/Library/components';
import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LibraryToolbar />
      <div className={classes.content}>
        <LibraryList /> 
      </div>
    </div>
  );
};
